import { render } from "./CookiesComp.vue?vue&type=template&id=bf854d5c&scoped=true&ts=true"
import script from "./CookiesComp.vue?vue&type=script&lang=ts"
export * from "./CookiesComp.vue?vue&type=script&lang=ts"

import "./CookiesComp.vue?vue&type=style&index=0&id=bf854d5c&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf854d5c"]])

export default __exports__